// Utilities
import { getCardStatusActivityIcon } from 'Modules/Card/common/helpers'

export default {
  computed: {
    actionIcon() {
      let icon = ''

      if (this.activity.type === 'comment') icon = 'far fa-comment-alt-lines'
      if (this.activity.type === 'status') icon = getCardStatusActivityIcon(this.activity.title)
      if (this.activity.type === 'item') icon = 'far fa-check-square'
      return icon
    },
  },
}
